module.exports = __webpack_public_path__ + "components/resort-condition/static/next-snowfall-b9c9cf7506eb53e185fa70a3072be8a7.svg";